import { jsx as _jsx } from "react/jsx-runtime";
import StyledBody from "./Body.style";
import { BodySizes, BodyVariants, BodyWeights } from "./constants";
const Body = ({ children, variant = BodyVariants.base, size = BodySizes.body_1, weight = BodyWeights.regular, ...props }) => (_jsx(StyledBody, { variant: variant, size: size, weight: weight, ...props, children: children }));
export default Body;
//# sourceMappingURL=Body.js.map